module.exports = __webpack_public_path__ + "static/media/meteringbanner@3x.024c4c3e.png";